import _ from 'underscore';
import { useRef } from 'react';

export function useDeepMemo<T>(value: T): T {
  const ref = useRef<T>();

  if (!_.isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}
